"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    attrs: {
      "return-menu": "/farm-management/dashboard",
      menu: _vm.page.children,
      subtitle: _vm.page.meta.title
    },
    scopedSlots: _vm._u([{
      key: "context",
      fn: function fn() {
        return [_c("section", {
          staticClass: "contracts-page"
        }, [_c("header", {
          staticClass: "page-header"
        }, [_c("h1", {
          staticClass: "page-title"
        }, [_vm._v("\n          Contratos\n        ")]), _vm._v(" "), _c("b-button", {
          staticClass: "btn plant-nursery-primary-btn",
          attrs: {
            type: "is-primary"
          },
          on: {
            click: _vm.openCreateModal
          }
        }, [_vm._v("\n          Registrar Contrato\n        ")])], 1), _vm._v(" "), _c("contracts-table", {
          attrs: {
            data: _vm.contracts,
            "is-loading": _vm.isLoading
          },
          on: {
            edit: _vm.openEditModal,
            delete: _vm.handleDelete
          }
        }), _vm._v(" "), _vm.meta.total > _vm.meta.perPage ? _c("b-pagination", {
          staticClass: "mt-4",
          attrs: {
            total: _vm.meta.total,
            current: _vm.meta.currentPage,
            "per-page": _vm.meta.perPage,
            "range-before": "2",
            "range-after": "2",
            size: "is-small",
            order: "is-centered"
          },
          on: {
            "update:current": function updateCurrent($event) {
              return _vm.$set(_vm.meta, "currentPage", $event);
            },
            change: _vm.handlePageChange
          }
        }) : _vm._e()], 1), _vm._v(" "), _c("create-contract-modal", {
          attrs: {
            "is-modal-active": _vm.isModalActive,
            "is-saving": _vm.isSaving,
            contract: _vm.selectedContract,
            customers: _vm.customersOptions,
            lots: _vm.lotsOptions,
            "on-fetch-lots": _vm.fetchLotsOptions,
            "on-fetch-customers": _vm.fetchCustomersOptions
          },
          on: {
            submit: _vm.handleModalSubmit,
            onClose: _vm.handleModalClose
          }
        })];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;